import {
  IconDefinition,
  IconFamily,
} from '@fortawesome/fontawesome-common-types';
import styledIcon, { IconStyles } from './styledIcon';

export const faHourglassHalf = hourglassHalf('classic', 'thin');
export const falHourglassHalf = hourglassHalf('classic', 'light');
export const fatHourglassHalf = hourglassHalf('classic', 'thin');
export const fadHourglassHalf = hourglassHalf('duotone', 'thin');
export const fasHourglassHalf = hourglassHalf('classic', 'solid');
export const farHourglassHalf = hourglassHalf('classic', 'regular');

export default function hourglassHalf(
  family: IconFamily,
  style: IconStyles
): IconDefinition {
  return styledIcon(
    family,
    style,
    'hourglass-half',
    384, // width
    512, // height
    'f252', // unicode
    [
      [
        'classic',
        'solid',
        'M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0zM96 75l0-11 192 0 0 11c0 19-5.6 37.4-16 53L112 128c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9L112 384z',
      ],
      [
        'classic',
        'regular',
        'M0 24C0 10.7 10.7 0 24 0L360 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 19c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445l0 19 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-19c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67l0-19-8 0C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5l184.4 0c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67l0-19L80 48l0 19c0 22.1 7 43.4 19.8 61l184.4 0z',
      ],
      [
        'classic',
        'light',
        'M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-41.6c0-49.4 22.8-96 61.8-126.3L165.9 256 93.8 199.9C54.8 169.6 32 122.9 32 73.6L32 32 16 32C7.2 32 0 24.8 0 16S7.2 0 16 0L48 0 336 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 41.6c0 49.4-22.8 96-61.8 126.3L218.1 256l72.2 56.1c39 30.3 61.8 76.9 61.8 126.3l0 41.6 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0L48 512l-32 0zm304-32l0-41.6c0-7.6-.7-15.1-2-22.4L66 416c-1.3 7.3-2 14.8-2 22.4L64 480l256 0zM113.4 337.4C97.3 349.9 84.6 366 76.1 384l231.7 0c-8.5-18-21.1-34.1-37.3-46.6L192 276.3l-78.6 61.1zM192 235.7l78.6-61.1c5.7-4.5 11-9.3 15.8-14.6L97.6 160c4.8 5.3 10.1 10.2 15.8 14.6L192 235.7zM307.9 128c7.9-16.8 12.1-35.4 12.1-54.4L320 32 64 32l0 41.6c0 19.1 4.2 37.6 12.1 54.4l231.7 0z',
      ],
      [
        'classic',
        'thin',
        'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8l24 0 0 55.2c0 48.3 23 93.7 61.8 122.4L178.5 256 93.8 318.4C55 347 32 392.5 32 440.8L32 496 8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l368 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0 0-55.2c0-48.3-23-93.7-61.8-122.4L205.5 256l84.7-62.4C329 165 352 119.5 352 71.2L352 16l24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 0zM336 16l0 55.2c0 19.9-4.3 39.2-12.4 56.8L60.4 128C52.3 110.4 48 91.1 48 71.2L48 16l288 0zM314.9 144c-8.9 14.1-20.5 26.6-34.2 36.7L192 246.1l-88.7-65.3C89.6 170.6 78 158.1 69.1 144l245.8 0zM192 265.9l88.7 65.3c28 20.7 46.8 51.1 53.1 84.7L50.3 416c6.2-33.7 25-64.1 53.1-84.7L192 265.9zM48 440.8c0-2.9 .1-5.9 .3-8.8l287.4 0c.2 2.9 .3 5.8 .3 8.8l0 55.2L48 496l0-55.2z',
      ],
      [
        'duotone',
        'thin',
        [
          'M48.3 432c-.2 2.9-.3 5.8-.3 8.8L48 496l288 0 0-55.2c0-2.9-.1-5.9-.3-8.8L48.3 432zM69.1 144c8.9 14.1 20.5 26.6 34.2 36.7L192 246.1l88.7-65.3c13.8-10.1 25.3-22.6 34.2-36.7L69.1 144z',
          'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8l24 0 0 55.2c0 48.3 23 93.7 61.8 122.4L178.5 256 93.8 318.4C55 347 32 392.5 32 440.8L32 496 8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l368 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0 0-55.2c0-48.3-23-93.7-61.8-122.4L205.5 256l84.7-62.4C329 165 352 119.5 352 71.2L352 16l24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 0zM336 16l0 55.2c0 19.9-4.3 39.2-12.4 56.8L60.4 128C52.3 110.4 48 91.1 48 71.2L48 16l288 0zM314.9 144c-8.9 14.1-20.5 26.6-34.2 36.7L192 246.1l-88.7-65.3C89.6 170.6 78 158.1 69.1 144l245.8 0zM192 265.9l88.7 65.3c28 20.7 46.8 51.1 53.1 84.7L50.3 416c6.2-33.7 25-64.1 53.1-84.7L192 265.9zM48 440.8c0-2.9 .1-5.9 .3-8.8l287.4 0c.2 2.9 .3 5.8 .3 8.8l0 55.2L48 496l0-55.2z',
        ],
      ],
    ]
  );
}
